// Stable default for optional `sx` props, so each render doesn't allocate a new array.
export const EMPTY_SX = [] as const;
